import { render } from "./ReturnApproval.vue?vue&type=template&id=d4768b1c&scoped=true"
import script from "./ReturnApproval.vue?vue&type=script&lang=js"
export * from "./ReturnApproval.vue?vue&type=script&lang=js"

import "./ReturnApproval.vue?vue&type=style&index=0&id=d4768b1c&scoped=true&lang=css"
import "./ReturnApproval.vue?vue&type=style&index=1&id=d4768b1c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4768b1c"]])

export default __exports__